
import React from 'react';
import { ClubMessage } from './types';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { format } from 'date-fns';

interface MessageBubbleProps {
  message: ClubMessage;
  isOwn: boolean;
  showAuthor: boolean;
}

const MessageBubble: React.FC<MessageBubbleProps> = ({ message, isOwn, showAuthor }) => {
  const messageTime = format(new Date(message.created_at), 'HH:mm');
  
  return (
    <div className={`flex gap-2 ${isOwn ? 'flex-row-reverse' : 'flex-row'}`}>
      {!isOwn && showAuthor && (
        <Avatar className="h-8 w-8 mt-1 flex-shrink-0">
          <AvatarImage src={message.author?.avatar_url || ""} alt="Avatar" />
          <AvatarFallback className="bg-blue-100 text-blue-600 text-xs">
            {message.author?.full_name?.charAt(0) || message.author?.username?.charAt(0) || "?"}
          </AvatarFallback>
        </Avatar>
      )}
      
      {!isOwn && !showAuthor && (
        <div className="w-8 flex-shrink-0" />
      )}
      
      <div className={`flex flex-col max-w-[70%] ${isOwn ? 'items-end' : 'items-start'}`}>
        {!isOwn && showAuthor && (
          <div className="text-xs text-muted-foreground mb-1 px-3">
            {message.author?.full_name || message.author?.username || "Anonymous"}
          </div>
        )}
        
        <div
          className={`rounded-2xl px-4 py-2 break-words ${
            isOwn
              ? 'bg-blue-600 text-white rounded-br-md'
              : 'bg-gray-100 text-gray-900 rounded-bl-md'
          }`}
        >
          <div className="whitespace-pre-wrap text-sm">{message.content}</div>
          <div className={`text-xs mt-1 opacity-70 ${isOwn ? 'text-right text-blue-100' : 'text-left text-gray-500'}`}>
            {messageTime}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MessageBubble;
